export enum DBOperation {
  create = 1,
  update = 2,
  delete = 3,
  detail = 4,
  upload =5,
  download = 6,
  doc = 7,
  child = 8,
  change = 9,
  deactivate = 10,
  customdetails = 11,
  customedit = 12,
  customdelete = 13,
  add=14,
  custumadd = 15,
  Accept = 16,
  Reject=17
}

export enum MessageType {
  Success,
  Danger,
  Warning,
  Info
}

export enum CLIENT_INFO {
   CLIENTNAME = 1,
   CLIENTKEY = 2,
   CLIENTID = 3
                 }


export class AppMessageEvents {
  public static UserAccountCreated: number = 1;
  public static AppointmentBooked: number = 3;
  public static AppointmentCancelled: number = 2;
}

export enum Export {
  Excel,
  HTML,
  XML,
  PDF,
  Text
}
export enum DateTimeInterval {
  Year = 0,
  Quarter = 1,
  Month = 2,
  DayOfYear = 3,
  Day = 4,
  WeekOfYear = 5,
  Weekday = 6,
  Hour = 7,
  Minute = 8,
  Second = 9,
  MilliSecond = 10
}
export enum AllowKey {
  Numeric = 1,
  Alphabetic,
  AlphaNumeric,
  AvoidSuperChar
}
export enum ControlType {
  Label,
  TextBox,
  ComboBox,
  CheckBox,
  Button,
  DateTime,
  DateTimeCheckBox,
  Group,
  Panel,
  LinkLabel
}
export enum FormatDateTime {
  TimeFormat,
  DateFormat,
  DateTimeFormat
}
export enum LockType {
  Lock = 1,
  Release = 2,
  CheckWithMessage = 3,
  CheckNoMessage = 4
}
export enum FormType {
  Entry = 0,
  Report = 1,
  Save = 2
}
export enum FormMode {
  Add = 0,
  Modify,
  View
}
export enum ToolBarButtons {
  Save = 0,
  SaveAs,
  View,
  Modify,
  Attachment,
  Export,
  Delete,
  Clear,
  Refresh,
  Stop,
  Print,
  EventLog,
  Close,
  Favorites,
  SendMessage,
  SendSMS,
  SendEMail,
  Help,
  Find,
  Initialize,
  Release
}

export enum Error_Message {
  ServiceFault,  //Cannot Communicate with Service or Service not running
  CommunicationFault,    //Communication Error / Network Error
  DBConnection,  //Cannot Connect to Database
  Init,   //Object Not Initialized
  NullError,   //Null value Error
  LoginName, //Invalid User
  LoginPassword //Invalid Password
}
export enum FormatStyle {
  DateFormat,
  DateSaveFormat,
  DateTimeFormat,
  DateTimeSaveFormat,
  TimeFormat
}
export enum MessageStyle {
  OkOnly,
  OkCancel,
  YesNo,
  Yes,
  No,
  Cancel,
  Critical,
  Information,
  YesNoCancel,
  RetryCancel,
  AbortRetryCancel,
  Saved,
  Deleted,
  Delete,
  AssignFlight,
  ViewAttachCancel,
  YesLaterCancel,
  CustomSaveMessage,
}
export enum MessageResult {
  Yes,
  No,
  Ok,
  Abort,
  Retry,
  Cancel,
  Later
}
export enum InputStyle {
  OkCancel,
  YesNo,
  Delete
}
export enum ProgressType {
  AcquiringData,
  Processing,
  TimeOut,
  DeletingData,
  Initialize,
  Refresh,
  Cancel,
  Progressing
}
export enum ReturnDataType {
  Integer,
  String
}


